var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgOwnershipType = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 19,
    fill: "none",
    viewBox: "0 0 20 19",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#7E869E",
    strokeWidth: 1.583,
    d: "M12.645 3.96c1.111 0 1.667 0 2.067.268.173.115.321.264.437.437.266.399.266.955.266 2.067v7.52c0 1.493 0 2.24-.463 2.704-.464.463-1.21.463-2.703.463h-4.75c-1.493 0-2.24 0-2.703-.463-.464-.464-.464-1.21-.464-2.703V6.732c0-1.112 0-1.668.267-2.067.115-.173.264-.322.437-.437.4-.267.955-.267 2.067-.267"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#7E869E",
    strokeWidth: 1.583,
    d: "M7.5 3.958c0-.874.709-1.583 1.583-1.583h1.584a1.583 1.583 0 0 1 0 3.167H9.083A1.583 1.583 0 0 1 7.5 3.958Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#7E869E",
    strokeLinecap: "round",
    strokeWidth: 1.583,
    d: "M7.5 9.5h4.75M7.5 12.664h3.167"
  })));
};
export default SvgOwnershipType;